import { TYPES } from "./types";
import { tkt1BankBrandService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1BankBrands = (query) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.getBankBrands(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRANDS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRANDS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1BankBrandByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.getBankBrandByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1BankBrandByCode = (code) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.getBankBrandByCode(code);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_CODE_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRAND_BY_CODE_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1BankBrands = (query) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.searchBankBrands(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_BANK_BRANDS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_BANK_BRANDS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1BankBrand = (bankBrandData) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.createBankBrand(bankBrandData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_BANK_BRAND_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_BANK_BRAND_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1BankBrand = (id, bankBrandData) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.updateBankBrand(id, bankBrandData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_BANK_BRAND_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_BANK_BRAND_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1BankBrand = (id) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.deleteBankBrand(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_BANK_BRAND_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_BANK_BRAND_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1BankBrandLogos = (id) => async (dispatch) => {
  try {
    const result = await tkt1BankBrandService.getBankBrandLogos(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRAND_LOGOS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_BANK_BRAND_LOGOS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1BankBrandAction = {
  getTKT1BankBrands,
  getTKT1BankBrandByID,
  getTKT1BankBrandByCode,
  searchTKT1BankBrands,
  createTKT1BankBrand,
  updateTKT1BankBrand,
  deleteTKT1BankBrand,
  getTKT1BankBrandLogos
};
